import type { InspectionTableRow } from "./clampQcInspectionTable";

export type ClampQcCartonSessionRow = InspectionTableRow & {
  clampSize?: "large" | "small";
  cartonInventoryBoxHex?: string | null;
};

export function mergeClampQcCartonTableRows(input: {
  serverRows: readonly InspectionTableRow[];
  sessionRows: readonly ClampQcCartonSessionRow[];
  openBoxHex: string;
}): InspectionTableRow[] {
  const bySerial = new Map<number, InspectionTableRow>();
  for (const row of input.serverRows) {
    bySerial.set(row.serial, row);
  }
  for (const sessionRow of input.sessionRows) {
    const inOpenBox =
      sessionRow.result.toLowerCase() === "passed" &&
      sessionRow.cartonInventoryBoxHex != null &&
      sessionRow.cartonInventoryBoxHex === input.openBoxHex;
    if (inOpenBox) {
      const { cartonInventoryBoxHex: _cartonHex, ...row } = sessionRow;
      bySerial.set(sessionRow.serial, row);
      continue;
    }
    if (bySerial.has(sessionRow.serial)) {
      bySerial.delete(sessionRow.serial);
    }
  }
  return [...bySerial.values()].sort((left, right) => {
    const leftTime = Date.parse(left.timestampIso);
    const rightTime = Date.parse(right.timestampIso);
    if (rightTime !== leftTime) {
      return rightTime - leftTime;
    }
    return right.serial - left.serial;
  });
}

export function filterClampQcRowsForOpenCarton(
  rows: readonly ClampQcCartonSessionRow[],
  openBoxHex: string | null | undefined,
): InspectionTableRow[] {
  if (openBoxHex == null || openBoxHex.trim() === "") {
    return [];
  }
  const compact = openBoxHex.trim();
  return rows
    .filter(
      (row) =>
        row.result.toLowerCase() === "passed" &&
        row.cartonInventoryBoxHex != null &&
        row.cartonInventoryBoxHex === compact,
    )
    .map(({ clampSize, cartonInventoryBoxHex: _cartonHex, ...row }) => ({ ...row, clampSize }));
}

export function filterClampQcSessionFailedRows(
  rows: readonly ClampQcCartonSessionRow[],
): ClampQcCartonSessionRow[] {
  return rows.filter((row) => row.result.trim().toLowerCase() === "failed");
}
